import React from "react";
import { styled } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { criteria } from "../../../static/criteria";

const Rubrics = () => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1C4E63",
      color: theme.palette.common.white,
      fontWeight: 700,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  return (
    <Box marginTop={{ xs: "20%", sm: "15%" }} data-aos={"fade-up"}>
      <Box marginLeft={{ xs: "0%", sm: "0%" }}>
        <Typography
          variant="h3"
          color="#D7A036"
          fontWeight={800}
          paddingBottom={"4%"}
          textAlign={"left"}
        >
          <Typography
            component={"span"}
            color="#831312"
            fontWeight={800}
            variant={"h3"}
          >
            Selection {""}
          </Typography>
          Rubrics
        </Typography>
      </Box>
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="left">S/N</StyledTableCell>
              <StyledTableCell align="left">Categories</StyledTableCell>
              <StyledTableCell align="left">Criteria</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {criteria.map((row, index) => (
              <TableRow key={index}>
                <StyledTableCell2 align="left">{index + 1}</StyledTableCell2>
                <StyledTableCell2 align="left">{row.title}</StyledTableCell2>
                <StyledTableCell2 align="left">
                  {row.description}
                </StyledTableCell2>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Rubrics;
